// extracted by mini-css-extract-plugin
export default {"timeSelect":"InputNumArrows_timeSelect__qkLxp","inputTime":"InputNumArrows_inputTime__0Nlu3","arrowIcon":"InputNumArrows_arrowIcon__bBi8I"};